module.exports = __webpack_public_path__ + "img/wordmark-eg.448f34aa.svg";